<template>
  <div>
    <TableCard
      ref="table"
      title="Locais de estoque"
      :headers="[
        {
          value: 'nome',
          text: 'Nome'
        },
        {
          value: 'cliente_nome',
          text: 'Cliente'
        },
        {
          value: 'endereco_cliente_string',
          text: 'Endereço'
        }
      ]"
      :indexer="api.locais_de_estoque.indexar"
      hideSearch
      @click:add="adicionarLocalEstoqueDialogo()"
    >
      <template v-slot:item.nome="{ item }">
        <router-link
          :to="{ name: 'locais_de_estoque_page', params: { id: item.id } }"
        >
          {{ item.nome }}
        </router-link>
      </template>
    </TableCard>
    <DialogoLista
      ref="produtos"
      title="Produtos"
      emptyMessage="Nenhum produto encontrado"
      :width="500"
      itemTitle="produto_nome"
      itemIcon="mdi-chevron-right"
      itemKey="id"
      :actions="[
        {
          name: 'add',
          text: 'Adicionar',
          color: 'primary',
          icon: 'mdi-plus'
        },
        {
          name: 'move',
          text: 'Transferir',
          color: 'primary',
          icon: 'mdi-transfer'
        },
        {
          name: 'remove',
          text: 'Remover',
          color: 'red',
          icon: 'mdi-delete',
          dark: true
        }
      ]"
      @click:add="handleOpenDialogoFormulario"
    >
      <template v-slot:item.title="{ item }">
        <b>{{ item.produto_nome }}</b> (x{{ item.quantidade }})
      </template>
    </DialogoLista>
    <DialogoFormulario
      ref="dialogoFormulario"
      title="Adicionar produto"
      :handler="handleAddProduto"
    >
      <template v-slot="{ form, errors }">
        <ServerSelectField
          v-model="form.produto"
          label="Produto"
          :error-messages="errors.produto"
          :loader="api.products.index"
          itemText="nome"
          itemValue="id"
        ></ServerSelectField>
        <v-text-field
          v-model="form.quantidade"
          label="Quantidade"
          type="number"
          :error-messages="errors.produto"
        ></v-text-field>
      </template>
    </DialogoFormulario>
    <DialogoTransferirEstoque ref="transferirEstoque" />
    <AdicionarLocalEstoqueDialogo
      ref="adicionarLocalEstoqueDialogo"
      @adicionado="$refs.table.loadItems()"
    />
  </div>
</template>

<script>
import TableCard from "@/components/tables/TableCard.vue";
import api from "@/services/locacoes";
import DialogoLista from "../../components/dialogos/DialogoLista.vue";
import DialogoFormulario from "../../components/dialogos/DialogoFormulario.vue";
import ServerSelectField from "../../components/selects/ServerSelectField.vue";
import DialogoTransferirEstoque from "../../components/locacoes/estoque/DialogoTransferirEstoque.vue";
import AdicionarLocalEstoqueDialogo from "@/components/locacoes/localEstoque/AdicionarLocalEstoqueDialogo.vue";

export default {
  components: {
    TableCard,
    DialogoLista,
    DialogoFormulario,
    ServerSelectField,
    DialogoTransferirEstoque,
    AdicionarLocalEstoqueDialogo
  },

  data() {
    return {
      api,
      localEstoque: null
    };
  },
  methods: {
    adicionarLocalEstoqueDialogo() {
      this.$refs.adicionarLocalEstoqueDialogo.open();
    },

    async handleAddProduto({ produto, quantidade }) {
      await api.locais_de_estoque.adicionarProduto(this.localEstoque.id, {
        produto_id: produto.id,
        quantidade
      });

      this.$refs.produtos.setLoading(true);

      try {
        const itens = await api.locais_de_estoque.indexarProdutos(
          this.localEstoque.id
        );
        this.$refs.produtos.items = itens;
      } catch (error) {
        console.error(error);
      } finally {
        this.$refs.produtos.setLoading(false);
      }
    },

    handleOpenDialogoFormulario() {
      this.$refs.dialogoFormulario.open({
        produto: null
      });
    },

    async handleClickLocalEstoque(local) {
      this.localEstoque = { ...local };
      this.$refs.produtos.open("Local de estoque", local.nome);
      this.$refs.produtos.setLoading(true);

      try {
        const itens = await api.locais_de_estoque.indexarProdutos(local.id);
        this.$refs.produtos.items = itens;
      } catch (error) {
        console.error(error);
      } finally {
        this.$refs.produtos.setLoading(false);
      }
    }
  }
};
</script>
